import React, { useContext, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import Card from "../components/common/Card";
import GradientButton from "../components/common/GradientButton";
import Label from "../components/common/Label";
import FormInput from "../components/FormInput";
import GradientBar from "../components/common/GradientBar";
import FormError from "../components/FormError";
import FormSuccess from "../components/FormSuccess";
import { FetchContext } from "../context/FetchContext";
import logo from "../images/logo.svg";

const Schema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
});

const ForgotPassword = () => {
  const history = useHistory();
  const fetchContext = useContext(FetchContext);
  const [signupSuccess, setSignupSuccess] = useState();
  const [signupError, setSignupError] = useState();
  const [loginLoading, setLoginLoading] = useState(false);

  const submitCredentials = async (credentials) => {
    try {
      setLoginLoading(true);
      const { data } = await fetchContext.publicAxios.post(
        `/forgot`,
        credentials
      );

      setSignupSuccess("Please check email");
      setSignupError("");

      setTimeout(() => {
        history.push("/");
      }, 10000);
    } catch (error) {
      setLoginLoading(false);
      const { data } = error.response;
      setSignupError(data.message);
      setSignupSuccess("");
    }
  };

  return (
    <>
      <section className="w-1/2 h-screen m-auto p-8 sm:pt-10">
        <GradientBar />
        <Card>
          <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full">
              <div>
                <div className="w-32 m-auto mb-6">
                  <img src={logo} alt="Logo" />
                </div>
                <h2 className="mb-2 text-center text-3xl leading-9 font-extrabold text-gray-900">
                  Reset password
                </h2>
              </div>
              <Formik
                initialValues={{
                  email: "",
                }}
                onSubmit={(values) => submitCredentials(values)}
                validationSchema={Schema}
              >
                {() => (
                  <Form className="mt-8">
                    {signupSuccess && <FormSuccess text={signupSuccess} />}
                    {signupError && <FormError text={signupError} />}
                    <input type="hidden" name="remember" value="true" />
                    <div>
                      <div className="mb-2">
                        <div className="mb-1">
                          <Label text="Email address" />
                        </div>
                        <FormInput
                          ariaLabel="Email address"
                          name="email"
                          type="email"
                          placeholder="Email address"
                        />
                      </div>
                    </div>

                    <div className="mt-6">
                      <GradientButton
                        type="submit"
                        text="Reset"
                        loading={loginLoading}
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </section>
    </>
  );
};

export default ForgotPassword;
